import Vue from 'vue'
import Router from 'vue-router'



Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect:'/index'
    },
    /*demo*/
    {
      path: '/demo',
      component: resolve => require(["../components/demo/demo"], resolve),
    },
    {
      path: '/auth',
      component: resolve => require(["../components/login/auth.vue"], resolve),
    },
    {
      path: '/loading',
      component: resolve => require(["../components/loading.vue"], resolve),
    },
    /*查询*/
    {
      path: '/fastquery',
      component: resolve => require(["../components/query/query002.vue"], resolve),
      // meta: {
      //   keepAlive: true
      // },
    },
    //查询购买国家
    {
      path: '/buyRules',
      component: resolve => require(["../components/query/buyRules.vue"], resolve),
      // meta: {
      //   keepAlive: true
      // },
    },
    //支付
    {
      path: '/payPublic',
      component: resolve => require(["../components/query/payPublic.vue"], resolve),
      // meta: {
      //   keepAlive: true
      // },
    },
    //支付成功
    {
      path: '/payConfirm',
      component: resolve => require(["../components/query/payConfirm.vue"], resolve),
      // meta: {
      //   keepAlive: true
      // },
    },
    {
      path: '/applicationTimestamp', // 申请时间戳
      component: resolve => require(['../components/Timestamp/applicationTimestamp.vue'], resolve),
      meta: {
          menuStatus: 'applicationTimestamp',
          title:'版权服务_申请时间戳 – 康信服务平台'
      }
    },
    {
      path: '/protectedWork', // 已保护作品
      component: resolve => require(['../components/Timestamp/protectedWork.vue'], resolve),
      meta: {
          menuStatus: 'protectedWork',
          title:'版权服务_已保护作品 – 康信服务平台'
      }
  },
  {
      path: '/myTimestamp', // 我的时间戳
      component: resolve => require(['../components/Timestamp/myTimestamp.vue'], resolve),
      meta: {
          menuStatus: 'myTimestamp',
          title:'版权服务_时间戳账户 – 康信服务平台'
      }
  },
  {
      path: '/Timestamp/applicantionConfirm', // 申请时间戳成功
      component: resolve => require(['../components/Timestamp/applicantionConfirm.vue'], resolve),
      meta: {
          menuStatus: 'confirm',
          title:'版权服务_申请时间戳 – 康信服务平台'
      }
  },
  {
    path: '/Timestamp/protectedWorkDetail', // 时间戳支付页面
    component: resolve => require(['../components/Timestamp/protectedWorkDetail.vue'], resolve),
    meta: {
        menuStatus: 'confirm',
        title:'版权服务_申请时间戳详情 – 康信服务平台'
    }
},
{
  path: '/myTimestampDetail', // 时间戳我的账户详情
  component: resolve => require(['../components/Timestamp/myTimestampDetail.vue'], resolve),
  meta: {
      menuStatus: 'confirm',
      title:'版权服务_申请时间戳详情 – 康信服务平台'
  }
},
{
    path: '/Timestamp/uploadImg', // 时间戳文件上传
    component: resolve => require(['../components/Timestamp/uploadImg.vue'], resolve),
    meta: {
        menuStatus: 'pd',
        title:'时间戳文件上传 – 康信服务平台'
    }
},
    /*我的*/
    {
      path: '/my',
      component: resolve => require(["../components/my/index003.vue"], resolve),
      redirect:'/myCenter',
      children:[
        {
          path: '/myCenter',
          component: resolve => require(["../components/my/my003.vue"], resolve),
        },
        {
          path: '/accountInformation',
          component: resolve => require(["../components/my/accountInformation004.vue"], resolve),
        },
        {
          path: '/modyfiAdd',
          component: resolve => require(["../components/my/modyfiAdd.vue"], resolve),
        },
        {
          path: '/applicantInformation',
          component: resolve => require(["../components/my/applicantInformation.vue"], resolve),
        },
        {
          path: '/BindMailbox',
          component: resolve => require(["../components/my/BindMailbox.vue"], resolve),
        },
        {
          path: '/discountCoupon',
          component: resolve => require(["../components/my/discountCoupon005.vue"], resolve),
        },
        {
          path: '/notificationMessage',
          component: resolve => require(["../components/my/notificationMessage006.vue"], resolve),
        },
        {
          path: '/feedback',
          component: resolve => require(["../components/my/feedback007.vue"], resolve),
        },
        {
          path: '/safetyManagement',
          component: resolve => require(["../components/my/binding_modify/safetyManagement013"], resolve),
          redirect:'/verifyPassword',
          children:[
            {
              path: '/changeEmail',
              component: resolve => require(["../components/my/binding_modify/changeEmail014"], resolve),
            },
            {
              path: '/verifyPassword',
              component: resolve => require(["../components/my/binding_modify/verifyPassword012"], resolve),
            },
            {
              path: '/verifyPhone',
              component: resolve => require(["../components/my/binding_modify/verifyPhone"], resolve),
            },
            {
              path: '/verify',
              component: resolve => require(["../components/my/binding_modify/verify011"], resolve),
            },
            {
              path: '/changePhoneNumber',
              component: resolve => require(["../components/my/binding_modify/changePhoneNumber010"], resolve),
            },
            {
              path: '/operateSuccessfully',
              component: resolve => require(["../components/my/binding_modify/operateSuccessfully009"], resolve),
            },
            {
              path: '/changePassword',
              component: resolve => require(["../components/my/binding_modify/changePassword008"], resolve),
            },
          ],
        },

      ]
    },
    
    // {
    //   path: '/queryResult',
    //   component: resolve => require(["../components/query/queryResult0813.vue"], resolve),
    // },
    {
      path: '/trademarkDetail',
      component: resolve => require(["../components/query/trademarkDetail014.vue"], resolve),
      meta: {
        keepAlive: true
      },
    },
    /*其他*/
    {
      path: '/classfy0',
      component: resolve => require(["../components/other/class015.vue"], resolve),
    },
    {
      path: '/classfy1',
      component: resolve => require(["../components/other/class016.vue"], resolve),
    },
    {
      path: '/classfy2',
      component: resolve => require(["../components/other/class017.vue"], resolve),
    },
    {
      path: '/question0',
      component: resolve => require(["../components/other/question018.vue"], resolve),
    },
    {
      path: '/question1',
      component: resolve => require(["../components/other/question019.vue"], resolve),
    },
    {
      path: '/introduce',
      component: resolve => require(["../components/other/introduce.vue"], resolve),
    },
    // 着陆页
    {
      path: '/index',
      component: resolve => require(["../components/index/index.vue"], resolve),
    },
  ]
});
const whiteList = ['/auth','/dawei','/demo','/classfy0','/classfy1','/classfy2','/question0','/question1','introduce']; // 不重定向白名单

router.beforeEach((to, from, next) => {
  //console.log(to.path,to.query);
  if(new Date()<new Date("2017-05-18 09:00:01")&&new Date()>new Date("2017-05-17 20:00:01")){
    // console.log("________________");
    window.localStorage.clear();
  }else{
    // console.log("-*-*-*-*-*-*-*-*-");
  }

  if (to.path=="/fastquery"&&from.path=="/trademarkDetail") {
    from.meta.keepAlive = false;
    to.meta.keepAlive = true
  }
  for (let key in handsomeLong.loading) {
    handsomeLong.loading[key].close();
  }
  next();
 
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js